import React, { useState } from 'react';
import Popup from "../imagepopup";

function Freelance() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setSelectedImage("");
  };
  return (
    
    <section className="sec-box project section-padding radius-15">
        <div className="next-prev">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="d-flex align-items-center">
              <div className="next ml-auto">
                <h6 className="sub-title back-to-work">
                  <a href="/works">
                  <i className="fas fa-long-arrow-alt-left"></i> Back to works
                  </a>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-lg-11">
          <div className="img mb-80">
            <img
              src="/assets/imgs/works/p2.jpg"
              alt=""
              className="radius-5"
            />
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-7">
              <div className="cont md-mb50">
              <h3 className="mb-15 fw-500">Project Description:</h3>
                <p>
                As a freelance UI/UX designer and front-end developer, I worked on multiple projects for various clients across industries, delivering high-quality, visually appealing, and user-centric web applications. Focused on crafting responsive, intuitive, and high-performance interfaces, ensuring seamless user experiences across customer portals, enterprise applications, e-commerce platforms, and service management tools.
                </p>
                <p className="mt-15">
                Leveraged HTML, CSS, JavaScript, jQuery, Bootstrap, and modern front-end frameworks to develop sleek and interactive applications. Collaborated with clients to translate business requirements into elegant design solutions, ensuring usability, accessibility, and engagement.
                </p>
                <div className="mt-30">
                <h6 className="mb-15 line-height-28">
                  Roles & Responsibilities:
                  </h6>
                 
                  <p>As a <strong>UI/UX Web Developer</strong>, I was responsible for:</p>
                  <ul className="rest list-arrow mt-50">
                    <li>
                      <h6 className="inline fz-15">End-to-End UI/UX Design: Designed wireframes, prototypes, and high-fidelity UI designs, ensuring optimal user flows and engagement.</h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Custom Web Application Development: Developed fully responsive, cross-browser-compatible, and mobile-friendly interfaces using HTML5, CSS3, JavaScript, and frameworks.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">User-Centric Portals & Dashboards: Created custom portals, data visualization dashboards, and interactive components to enhance user experience.</h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Performance & Accessibility Optimization: Ensured fast-loading UI components, adhering to WCAG accessibility standards for inclusivity.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Branding & UI Consistency: Delivered pixel-perfect designs, maintaining brand identity and visual consistency across all platforms.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      SEO & Web Performance Enhancements: Optimized front-end code for search engine visibility and improved website performance.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Client Collaboration & Agile Development: Worked closely with businesses, product managers, and developers to align UI/UX with client expectations in agile workflows.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-185">
                      CMS & E-commerce UI Enhancements: Designed and customized themes for WordPress, Shopify, and other CMS platforms, improving user engagement and conversion rates.
                      </h6>
                    </li>
                  </ul>
                  <p className="mt-25">
                  Through freelance projects, I successfully delivered modern, scalable, and highly engaging digital experiences, helping clients improve their brand presence, user retention, and overall digital performance across diverse industries. </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="info sub-bg" id="sticky_item">
                <ul>
                  <li className="mb-30">
                    <span className="sub-title">
                      <i className="far fa-calendar-alt mr-10"></i> Date :
                    </span>
                    <p>6, August 2022</p>
                  </li>
                  <li className="mb-30">
                    <span className="sub-title">
                      <i className="fas fa-list-ul mr-10"></i> Categories :
                    </span>
                    <p>Web Design</p>
                  </li>
                  <li className="mb-30">
                    <span className="sub-title">
                      <i className="far fa-user mr-10"></i> Client :
                    </span>
                    <p>Themeforest</p>
                  </li>
                  <li>
                    <span className="sub-title">
                      <i className="fas fa-globe mr-10"></i> Website :
                    </span>
                    <p>UI_ThemeZ.com</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="imgs mt-80">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="row md-marg">
              <div className="col-md-6">
                <div className="img sm-mb30">
                  <img src="/assets/imgs/works/p10.jpg" alt="" onClick={() => handleImageClick("/assets/imgs/works/p10.jpg")} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="img">
                  <img src="/assets/imgs/works/p45.jpg" alt="" onClick={() => handleImageClick("/assets/imgs/works/p45.jpg")} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="next-prev">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="d-flex align-items-center mt-80 pt-80 bord-thin-top">
              <div className="prev">
                <h6 className="sub-title">
                  <a href="/techmahindra">
                    <i className="fas fa-long-arrow-alt-left"></i> Prev Project
                  </a>
                </h6>
              </div>
              <div className="next ml-auto">
                <h6 className="sub-title">
                  <a href="/deloitte">
                    next Project <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
            {/* Popup for images */}
            <Popup
        isOpen={isPopupOpen}
        closePopup={closePopup}
        popupImage={selectedImage}
      />
    </section>
  );
}

export default Freelance;
